export { default } from "./useSubscriptionConfig";
export * from "./useSubscriptionConfig";
